/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partnersempty1Inputs */

const en_partnersempty1 = /** @type {(inputs: Partnersempty1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No partners yet.`)
};

const de_partnersempty1 = /** @type {(inputs: Partnersempty1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Partner.`)
};

/**
* | output |
* | --- |
* | "No partners yet." |
*
* @param {Partnersempty1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const partnersempty1 = /** @type {((inputs?: Partnersempty1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partnersempty1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_partnersempty1(inputs)
	return de_partnersempty1(inputs)
});
export { partnersempty1 as "partnersEmpty" }